import React from 'react';
import {Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid} from '@material-ui/core'
import UseriList from '../UseriList'


 

export default class AddUserDrepturi extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
     
         }
    }

     componentDidMount(){
  
    }

   
     render() { 
       return (
          <div>
               <Dialog 
                 className="pm-alert-dialog"
                disableEscapeKeyDown
                fullWidth={true}
                maxWidth='sm'
                 open={this.props.open}
                 onClose={this.props.dialogClose}>
                 <DialogActions >
                 <Fab  onClick={this.props.dialogClose} className="pm-round-button-dialog">
                                      <i className='material-icons pm-round-button-text-dialog'>close</i>
                            </Fab>
                 </DialogActions>
                 <h2 className='pm-dialog-alert-title'>{this.props.title}</h2>

                    <div className='container' style={{textAlign:'center'}}>
                
                            <UseriList
                                dialogDisplay={1}
                                elemente={this.props.listUsers}
                                dict={this.props.limba}
                                onlyColumns={{nume:'nume'}}
                                onElClick={this.props.userClick}
                                />
                </div>       

                       
                   
                 </Dialog>
         </div>
        );
       }
}